import { render } from "./SwapView.vue?vue&type=template&id=6453b0ea&ts=true"
import script from "./SwapView.vue?vue&type=script&lang=ts"
export * from "./SwapView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__